<template>
	<section>
		<div class="bg-color-content-primary marketing-section">
			<div class="container">
				<div
					class="display-flex flex-wrap-wrap justify-content-center col-12 col-8-md gap-300-lg gap-150 ml-auto mr-auto"
				>
					<h3 class="heading-1 text-color-white text-align-center"
						>Add private real estate to your portfolio</h3
					>
					<div class="col-12 col-9-md">
						<slot name="lead-capture"> </slot>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.lead-capture-wrapper {
	max-width: 450px;
}
</style>
